module.exports = __webpack_public_path__ + "img/haufe.793f0cf7.jpg";